//make a compont with a name "TeamsTable" that will take a prop "teams" and render a table with the following columns
import React, { useEffect, useState } from "react";
import { useStores } from "../../../store";
import { roles, teamRoles } from "../../../helpers/constantVariables";
import Loader from "../loader";
import { MdEdit, MdOutlineAccessTime } from "react-icons/md";
import Addnumber from "./newnumber";
import { useObserver } from "mobx-react";
import { toJS } from "mobx";
import { LuDot } from "react-icons/lu";
import ReactPaginate from "react-paginate";
import UserStore from "../../../store/user_store";

const API = "/api/user/all-members/ownerId";

const TeamsTable = ({ teams }) => {
  const { RecuiterStore } = useStores();
  const [showAddNumberPopup, setShowAddNumberPopup] = useState(false);
  const [data, setData] = useState([]);
  const [role, setRole] = useState("");
  const [teamOwnerPresent, setTeamOwnerPresent] = useState(false);
  const fetchTableData = async () => {
    try {
      RecuiterStore.fetchAllTeamMembers().then((res) => {
        console.log("res", toJS(RecuiterStore.Teams));
        if (RecuiterStore.teamOwnerId) {
          // find me in the team members.
          const TeamMaintainer = RecuiterStore.Teams.find(
            (team) => team?.userId?._id === RecuiterStore.UserId
          );
          console.log("TeamMaintainer", TeamMaintainer?.roleId);
          if (TeamMaintainer?.roleId) {
            // setRole(TeamMaintainer?.roleId);
            console.log(
              teamRoles.find((role) => role.id === TeamMaintainer?.roleId)
            );
            setRole(
              teamRoles.find((role) => role.id === TeamMaintainer?.roleId)?.role
            );
            console.log("role", role);
          }
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageClick = (page) => {
    RecuiterStore.fetchAllTeamMembers({ skip: page.selected * 10 });
  };

  const getColor = (status) => {
    switch (status) {
      case "pending":
        return "text-yellow";
      case "registered":
        return "text-green-500";
      case "blocked":
        return "text-red-500";
      default:
        return "";
    }
  };

  let shimmer = {
    numRows: 5,
    rowHeight: "4rem",
    bgColor: "bg-gray-100",
    showProfilePic: true,
    page: "",
    headerTitles: [
      { name: "Profile pic", width: "5%" },
      { name: "Name", width: "15%" },
      { name: "Email ID", width: "20%" },
      { name: "Applied date", width: "15%" },
      { name: "Applied for", width: "15%" },
      { name: "Total Score", width: "10%" },
      { name: "Status", width: "10%" },
    ],
    rowBoxes: [
      {
        width: "15%",
        height: "1.2rem",
        shape: "rectangle",
      },
      {
        width: "20%",
        height: "1.2rem",
        shape: "rectangle",
      },
      {
        width: "15%",
        height: "1.2rem",
        shape: "rectangle",
      },
      {
        width: "15%",
        height: "1.2rem",
        shape: "rectangle",
      },
      {
        width: "10%",
        height: "1.2rem",
        shape: "rectangle",
      },
      {
        width: "10%",
        height: "1.2rem",
        shape: "rectangle",
      },
    ],
  };

  const timeStampToDate = (timestamp) => {
    const date = new Date(timestamp);
    const dayOfWeek = date.toLocaleDateString("en-US", { weekday: "long" });
    const fullDate = date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    return `${fullDate}`;
  };

  useEffect(() => {
    if (RecuiterStore.Teams.length < 1) {
      fetchTableData();
      setTeamOwnerPresent(RecuiterStore.teamOwnerId ? true : false);
      console.log(
        "Teams",
        RecuiterStore.teamOwnerId ? RecuiterStore.teamOwnerId : "No team owner"
      );
    }
  }, []);
  return useObserver(() => (
    <div className="border-b-2">
      {showAddNumberPopup && (
        <Addnumber
          buttonName={"update"}
          edit={true}
          data={data}
          onClick={() => setShowAddNumberPopup(false)}
        />
      )}
      {/* <Loader loader={RecuiterStore.loader} /> */}
      <table className="overflow-x-auto hidden md:table lg:table min-w-full md:mt-3 lg:mt-4 rounded-lg">
        <thead className="bg-[#FEEFD6] rounded-lg h-14">
          <tr>
            <th className="px-4 py-2 text-center text-[#151414] font-medium rounded-l-lg">
              Name
            </th>
            <th className="px-4 py-2 text-center text-[#151414] font-medium">
              Mail ID
            </th>
            <th className="px-4 py-2 text-center text-[#151414] font-medium">
              Designation
            </th>
            <th className="px-4 py-2 text-center text-[#151414] font-medium">
              Date of joining
            </th>
            <th className="px-4 py-2 text-center text-[#151414] font-medium">
              Role
            </th>
            <th className="px-4 py-2 text-center text-[#151414] font-medium">
              Status
            </th>
            <th className="px-4 py-2 text-center text-[#151414] font-medium rounded-r-lg">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {RecuiterStore.Teams < 1 && !RecuiterStore.loader && (
            <tr>
              <td
                colSpan="8"
                className="p-20 text-center text-2xl font-bold text-primary"
              >
                No team members found
              </td>
            </tr>
          )}
          {RecuiterStore.loader && (
            <>
              {Array.from({ length: shimmer.numRows }).map((_, index) => (
                <tr
                  key={index}
                  className={`${shimmer.bgColor} animate-pulse border-b-2 border-slate-300`}
                  style={{ height: shimmer.rowHeight }}
                >
                  {Array.from({ length: 7 }).map((_, idx) => (
                    <td key={idx} className="px-4 py-2 text-center">
                      <div
                        className={`bg-gray-300 rounded-md mx-2 animate-pulse`}
                        style={{ width: "100px", height: "20px" }}
                      ></div>
                    </td>
                  ))}
                </tr>
              ))}
            </>
          )}

          {RecuiterStore.Teams.map((team) => (
            <tr
              colSpan="7"
              className=" items-center h-20  py-4 border-b-2 border-slate-300"
            >
              <td className="px-4 py-2 text-center text-[#717171]">
                {team?.name ?? "-"}
              </td>
              <td className="px-4 py-2 text-center text-[#717171]">
                {team?.email ? (team?.email === "" ? "-" : team?.email) : "-"}
              </td>
              <td className="px-4 py-2 text-center text-[#717171]">
                {team?.designation
                  ? team?.designation === ""
                    ? "-"
                    : team?.designation
                  : "-"}
              </td>
              <td className="px-4 py-2 text-center text-[#717171]">
                {timeStampToDate(team?.createdAt)}
              </td>

              <td className="px-4 py-2 text-center text-[#717171]">
                {teamRoles.find((role) => role.id === team?.accessType)?.role}
              </td>
              <td className="px-4 py-2 text-center text-[#717171]">
                <select
                  // disabled={(!JSON.parse(localStorage.getItem("user"))?.teamOwner || role === "Admin") ? true : false}
                  value={team?.status}
                  className={`focus:outline-none w-[5.5rem]  md:w-[5.5rem] lg:w-[7rem]   ${
                    !JSON.parse(localStorage.getItem("user"))?.teamOwner ||
                    role === "Admin"
                      ? `${getColor(team?.status)} cursor-pointer `
                      : "text-gray-500 cursor-not-allowed"
                  }`}
                  onChange={(e) => {
                    if (
                      !JSON.parse(localStorage.getItem("user"))?.teamOwner ||
                      role === "Admin"
                    ) {
                      RecuiterStore.updateMember(
                        { status: e.target.value },
                        team?._id
                      );
                    } else {
                      alert(
                        "You are not authorized to change the status of the team member"
                      );
                    }
                  }}
                >
                  <option value="pending" className="text-yellow">
                    Pending
                  </option>
                  <option value="registered" className="text-green-500">
                    Registered
                  </option>
                  {/* <option value="active">Active</option> */}
                  <option value="blocked" className="text-red-500">
                    Blocked
                  </option>
                </select>
              </td>
              <td
                className={`px-4 py-2 text-center   ${
                  !JSON.parse(localStorage.getItem("user"))?.teamOwner ||
                  role === "Admin"
                    ? "text-primary cursor-pointer"
                    : "text-gray-500 cursor-not-allowed"
                }`}
                onClick={() => {
                  if (
                    !JSON.parse(localStorage.getItem("user"))?.teamOwner ||
                    role === "Admin"
                  ) {
                    setData(team);
                    setShowAddNumberPopup(true);
                  } else {
                    alert("You are not authorized to edit the team member");
                  }
                }}
              >
                {" "}
                <span className="flex gap-2 cursor-pointer items-center justify-center">
                  <MdEdit /> Edit
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {RecuiterStore.Teams.count > 10 && (
        <div className="md:block lg:block hidden">
          <ReactPaginate
            nextLabel=" >"
            className="flex justify-center items-center gap-5 my-4"
            onPageChange={handlePageClick}
            pageRangeDisplayed={3}
            marginPagesDisplayed={2}
            pageCount={RecuiterStore.Teams.count / 10}
            previousLabel="< "
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active-page-item"
            activeLinkClassName="active-page-link"
            renderOnZeroPageCount={null}
          />
        </div>
      )}
      {/* {RecuiterStore.Teams < 1 && (
        <tr>
          <td
            colSpan="8"
            className="p-20 text-center text-2xl font-bold text-primary"
          >
            No team members found
          </td>
        </tr>
      )} */}
      {RecuiterStore.Teams.map((team) => (
        <div
          // key={applicant._id}
          className="md:hidden lg:hidden bg-white p-4 mb-3 h-[15%]  rounded-lg shadow-lg flex  "
        >
          <div className="md:hidden lg:hidden mr-0 pt-0 pl-0 p-3 w-[20%]">
            <img
              src={team?.pic}
              alt=""
              className="rounded-full bg-black w-10 h-10"
            />
          </div>
          <div className="flex flex-col w-full  ">
            <div className="flex justify-between items-center ">
              <h1 className="">{team?.name ?? "-"}</h1>
              <h1 className="text-xs ml-auto ">
                <select
                  value={team?.status}
                  className={`focus:outline-none ${getColor(team?.status)}`}
                  onChange={(e) => {
                    RecuiterStore.updateMember(
                      { status: e.target.value },
                      team?._id
                    );
                  }}
                >
                  <option value="pending" className="text-yellow">
                    Pending
                  </option>
                  <option value="registered" className="text-green-500">
                    Registered
                  </option>
                  {/* <option value="active">Active</option> */}
                  <option value="blocked" className="text-red-500">
                    Blocked
                  </option>
                </select>
              </h1>
            </div>
            <div className="flex flex-row gap-14 mt-1 items-center">
              <h1 className=" text-xs flex items-center text-[#717171] ">
                <LuDot />
                {team?.designation ?? "-"}
              </h1>
              <h1 className=" text-xs flex items-center text-[#717171] ">
                <LuDot />
                {teamRoles.find((role) => role.id === team?.roleId)?.role}{" "}
              </h1>
            </div>
            <h1 className="text-xs mt-1 items-center flex text-[#717171] ">
              <LuDot />
              {team?.email}
            </h1>
            <h1> </h1>
            <div className="flex  text-[#717171] justify-between items-center">
              <h1 className="flex justify-center  text-xs ">
                <MdOutlineAccessTime className="text-[12px] mt-[1px] " />
                {timeStampToDate(team?.createdAt)}
              </h1>
              <h1
                className={`px-4 py-2 text-center   ${
                  !JSON.parse(localStorage.getItem("user"))?.teamOwner ||
                  role === "Admin"
                    ? "text-primary cursor-pointer"
                    : "text-gray-500 cursor-not-allowed"
                }`}
                onClick={() => {
                  if (
                    !JSON.parse(localStorage.getItem("user"))?.teamOwner ||
                    role === "Admin"
                  ) {
                    setData(team);
                    setShowAddNumberPopup(true);
                  } else {
                    alert("You are not authorized to edit the team member");
                  }
                }}
              >
                <span className="flex text-black text-xs gap-2 cursor-pointer ">
                  Edit
                  <MdEdit />
                </span>
              </h1>
            </div>

            {/* <h1>
                          <span
                            className={
                              applicant.status === "success"
                                ? "text-green-500"
                                : "text-red-500"
                            }
                          >
                            {applicant.status}
                          </span>
                        </h1> */}
          </div>
        </div>
      ))}
    </div>
  ));
};

export default TeamsTable;
